import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tier-price-form"
export default class extends Controller {
  static targets = ["rows", "template", "unitPrice", "expectedCount", "forecastTotal"];
  static values = { index: Number };

  connect() {
    this.recalculate();
  }

  add(event) {
    event.preventDefault();

    const html = this.templateTarget.innerHTML.replaceAll("__INDEX__", this.indexValue);
    this.rowsTarget.insertAdjacentHTML("beforeend", html);
    this.indexValue += 1;
    this.recalculate();
  }

  remove(event) {
    event.preventDefault();
    event.currentTarget.closest("[data-tier-price-form-row]")?.remove();
    this.recalculate();
  }

  recalculate() {
    if (!this.hasForecastTotalTarget) return;

    const total = this.unitPriceTargets.reduce((sum, unitPrice, index) => {
      const price = Number.parseFloat(unitPrice.value);
      const count = Number.parseFloat(this.expectedCountTargets[index]?.value);

      return Number.isFinite(price) && Number.isFinite(count) ? sum + (price * count) : sum;
    }, 0);

    this.forecastTotalTarget.textContent = `预计基础金额：￥${total.toFixed(2)}（仅供录入核对，保存后以服务端计算为准）`;
  }
}
